
export const isMobile = () => /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
export const isThinDevice = () => {
  return isMobile() || window.innerWidth < 600;
}
